import { DeleteButton, EditButton, List, useTable } from "@refinedev/antd";
import { Button, Form, Input, Popover, Select, Space, Table, Tooltip, Typography } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { debounce } from "lodash";
import { useState } from "react";
import { IconDisplay } from "../../components/IconDisplay";

const { Title } = Typography;

export function CategoriesList() {
  const [hoveredRow, setHoveredRow] = useState<string>();

  const { tableProps, searchFormProps } = useTable({
    resource: "category",
    syncWithLocation: true,
    queryOptions: {
      keepPreviousData: false,
      cacheTime: 0,
      staleTime: 0,
    },
    meta: {
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    },
    onSearch: (values: any) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q,
        },
        {
          field: "status",
          operator: "eq",
          value: values.status,
        },
      ];
    },
  });

  const handleSearchChange = debounce(() => {
    searchFormProps.form?.submit();
  }, 500);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (value: string) => (
        <Tooltip
          title={value || "-"}
          placement="top"
          overlayStyle={{ maxWidth: "385px", maxHeight: "200px", overflow: "auto" }}
        >
          <span>{value ? `${value.slice(0, 50)}${value.length > 50 ? "..." : ""}` : "-"}</span>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Rank",
      dataIndex: "rank",
    },
    {
      title: "Image",
      dataIndex: "mediaURL",
      render: (mediaURL: string) => (
        <IconDisplay iconURL={mediaURL} width={36} height={36} borderRadius="8px" />
      ),
    },
    {
      title: "Actions",
      render: (_: any, record: any) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record.id} />
          <DeleteButton hideText size="small" recordItemId={record.id} />
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: "4px", position: "relative" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 10,
          width: "100%",
          justifyContent: "flex-end",
          alignItems: "flex-start",
        }}
      >
        <Form {...searchFormProps} onValuesChange={handleSearchChange}>
          <Title level={4}>Filter and Search</Title>
          <div style={{ display: "flex", gap: 10 }}>
            <Popover
              placement="bottomRight"
              trigger="click"
              content={
                <>
                  <Form.Item name="status" label="Status">
                    <Select placeholder="Select status" allowClear style={{ width: 220 }}>
                      <Select.Option value="ACTIVE">ACTIVE</Select.Option>
                      <Select.Option value="INACTIVE">INACTIVE</Select.Option>
                      <Select.Option value="DELETED">DELETED</Select.Option>
                    </Select>
                  </Form.Item>
                </>
              }
            >
              <Button icon={<FilterOutlined />}>Filters</Button>
            </Popover>
            <Form.Item name="q">
              <Input placeholder="Search by title or description" />
            </Form.Item>
          </div>
        </Form>
      </div>

      <List>
        <Table
          {...tableProps}
          columns={columns}
          rowKey="id"
          pagination={{
            ...tableProps.pagination,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `Total ${total} items`,
          }}
          onRow={(record: any) => ({
            onMouseEnter: () => setHoveredRow(record.id),
            onMouseLeave: () => setHoveredRow(""),
          })}
        />
      </List>
    </div>
  );
}







